import { TreeRow } from './documentTreeTypes'
import { selectRangeByOrder, SelectionResult } from '../../../helpers/selectionHelper'

export { toggleSelect } from '../../../helpers/selectionHelper'
export type { SelectionResult } from '../../../helpers/selectionHelper'

// The rows in the order FlatTree renders them: depth-first over `rows` (which is already
// in render order), keeping only rows whose ancestor folders are all open. Range selection
// and Ctrl+A operate on this visible order.
export const computeVisibleRowOrder = (rows: TreeRow[], openIds: ReadonlySet<string>): string[] => {
    const rowById = new Map(rows.map(row => [row.id, row]))
    const visible: string[] = []
    for (const row of rows) {
        let ancestor = row.parentId ? rowById.get(row.parentId) : undefined
        let allOpen = true
        while (ancestor) {
            if (!openIds.has(ancestor.id)) {
                allOpen = false
                break
            }
            ancestor = ancestor.parentId ? rowById.get(ancestor.parentId) : undefined
        }
        if (allOpen) {
            visible.push(row.id)
        }
    }
    return visible
}

// Shift+click: add the visible range between the anchor and the target to the selection.
// Ranges include folders unless includeFolders is false (e.g. the task attachment picker,
// where only files make sense as attachments). The range itself lives in
// helpers/selectionHelper so the email tab can share it; only the folder rule is local.
export const selectRange = (
    rows: TreeRow[],
    visibleOrder: string[],
    anchorId: string | undefined,
    targetId: string,
    selected: ReadonlySet<string>,
    includeFolders: boolean = true,
): SelectionResult => {
    if (includeFolders) {
        return selectRangeByOrder(visibleOrder, anchorId, targetId, selected)
    }
    const rowById = new Map(rows.map(row => [row.id, row]))
    return selectRangeByOrder(visibleOrder, anchorId, targetId, selected, id => rowById.get(id)?.isFolder === true)
}

// Ctrl+A: select every visible file (never folders).
export const selectAllVisibleFiles = (rows: TreeRow[], visibleOrder: string[]): SelectionResult => {
    const rowById = new Map(rows.map(row => [row.id, row]))
    return { next: new Set(visibleOrder.filter(id => rowById.get(id)?.isFolder === false)) }
}
